/*
 * File: UserMenu.js
 * Project: patient-portal
 *
 * Created by Nate Weber on 08/10/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Component that displays the authenticated user
 * and provides a list of actions in a menu.
 */

import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react";

import {
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import AccountIcon from "@material-ui/icons/AccountCircleRounded";
import ExitIcon from "@material-ui/icons/ExitToApp";
import DownArrowIcon from "@material-ui/icons/KeyboardArrowDownRounded";

import { useAppStore } from "stores/AppStore";

const useStyles = makeStyles(theme => ({
  button: {
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.primary
    }
  }
}));

const UserMenu = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const history = useHistory();
  const app = useAppStore();

  const handleLogout = async () => {
    await app.auth.logout();
    history.push("/");
  };

  const user = app.auth.portalUser;
  const greeting = user ? `Hello, ${user.fullName}` : "";

  return (
    <div>
      <Button
        color="inherit"
        onClick={e => setAnchorEl(e.currentTarget)}
        startIcon={<AccountIcon />}
        endIcon={<DownArrowIcon />}
        className={classes.button}
      >
        {greeting}
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <ExitIcon />
          </ListItemIcon>
          <ListItemText>Log Out</ListItemText>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default observer(UserMenu);
